export default __webpack_public_path__ + "static/media/trog_logo.75f3474c.png";